import { Icon } from '@iconify/react';

interface IIcon {
  width: string;
  color: string;
}
const RefreshIcon = ({ width, color }: IIcon) => (
  <Icon width={width} color={color} icon="bx:refresh" />
);

export default RefreshIcon;
